// extracted by mini-css-extract-plugin
export default {"tips":"ApplyModal_tips__Xg58w"};